export enum AutoLayoutAlignEnum {
  TOP_LEFT,
  TOP_CENTER,
  TOP_RIGHT,
  LEFT,
  CENTER,
  RIGHT,
  BOTTOM_LEFT,
  BOTTOM_CENTER,
  BOTTOM_RIGHT,
}

export enum AutoLayoutDirectionEnum {
  HORIZONTAL,
  VERTICAL,
}

export enum AutoLayoutResizingEnum {
  HUG,
  FILL,
  FIXED,
}
